import * as demoBrand from "./demoBrand";
import { SHIPMENT_SOLUTION_TYPES } from "~/cores/shipment.core";

export function getProducts() {
    let products = demoBrand.getProducts();
    products.shipmentSolutions.push({
        carrier: "HM_STORE",
        type: SHIPMENT_SOLUTION_TYPES.RETURN_IN_STORE.key,
        cost: 0,
    });

    return products;
}

export function getExchangeToProducts(props) {
    return demoBrand.getExchangeToProducts(props);
}

export function getSimilarProducts(props) {
    return demoBrand.getSimilarProducts(props);
}
